module.exports = __webpack_public_path__ + "img/10n.a92c08c2.png";